var _defs, _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _rect, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse2, _path15, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _path16, _rect2, _path17, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirlSitting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_13",
    "data-name": "Layer 13",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.11 576.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c4e7eb;}.cls-2{fill:#2baae2;}.cls-3{fill:#eec6aa;}.cls-4{fill:#144d66;}.cls-5{fill:#e4b798;}.cls-6{fill:#1f6c8e;}.cls-7{fill:#e8f5f7;}.cls-8{fill:#4096cc;}.cls-9{fill:#61cbf3;}.cls-10{fill:#96d9f2;}.cls-11{fill:#cc9e7f;}.cls-12{fill:#d3a484;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1799.34,2806.89a10,10,0,0,0,.23-2.13,10.69,10.69,0,0,0-10.87-10.5h-.37A14.8,14.8,0,0,0,1773.8,2783a15,15,0,0,0-12,5.94,11,11,0,0,0-8.13-3.53,10.68,10.68,0,0,0-10.86,10.5,10,10,0,0,0,.3,2.46c-.35,0-.7,0-1.06,0a13.47,13.47,0,1,0-.37,26.93,10.5,10.5,0,0,0,4.57,1h36.85a10.39,10.39,0,0,0,5.22-1.4,11.08,11.08,0,0,0,5.41,1.4,10.69,10.69,0,0,0,10.87-10.5A10.43,10.43,0,0,0,1799.34,2806.89Zm-38.37-2.13h-1.45a9.54,9.54,0,0,0,1-.73C1760.68,2804.28,1760.82,2804.52,1761,2804.76Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1697.6,3177.4H1592.52c-.29-17.76-.33-44,1.11-75.83,2.74-60.59,7.62-70.47,13.82-77.25,18.71-20.49,57.36-21.44,75.61-1.8C1690.62,3030.65,1699.16,3136.32,1697.6,3177.4Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1729.75,3205.38l-5.17,50.34a280.08,280.08,0,0,1-71.11-5.85c-28.15-6-50.7-11.8-59.28-29.09-3.53-7.11-3.35-14.31-3-28.7a130.5,130.5,0,0,1,4.44-30.73Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1677.71,2970.1c2.33,10.27-10.67,26.76-27.32,30.06-14.05,2.79-30.27-3.9-34.33-14-1.82-4.52.4-5.79-1.7-17.35-1.71-9.48-3.67-11.19-2.82-16.35,1-5.82,4.41-9.7,8.21-14,4.42-4.94,8.66-9.68,16-11.64a26.19,26.19,0,0,1,22.86,4.62,25.61,25.61,0,0,1,6.85,9c2.79,5.88,1.44,8.61,3.25,14.63C1671.44,2964.2,1676.45,2964.53,1677.71,2970.1Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1659.76,2934.54c-5.82.55-12.68,2.25-16.13,7.47-5.64,8.53.42,22.54-1.47,23.13-1.57.49-5-9.34-7.64-8.88-2.48.43-.34,10.12-5.4,18.45a31.19,31.19,0,0,1-13.06,11.47,180.44,180.44,0,0,1-9-36c-1.52-10.92-1-15.08,1.19-18.73,3.63-6,10.12-7.65,22.5-10.83,12.17-3.13,22.18-5.7,28-.41.59.52,5,4.61,4.05,9.45A8.81,8.81,0,0,1,1659.76,2934.54Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1638.6,
    cy: 2964.51,
    rx: 5.62,
    ry: 11.54,
    transform: "translate(-1810.49 -2614.78) rotate(-5.43)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1705.37,3198.06l-47.78,13.77A381.67,381.67,0,0,1,1605,3021.49c2.23-3,9.27-11.67,18.88-11.66,9.41,0,16.26,8.39,20.65,14.36,25.79,35.08,36.83,78.15,36.83,78.15C1692.78,3146.91,1700.79,3179.35,1705.37,3198.06Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1697.6,3177.4H1592.52c-.29-17.76-.33-44,1.11-75.83,2.74-60.59,7.62-70.47,13.82-77.25,18.71-20.49,57.36-21.44,75.61-1.8C1690.62,3030.65,1699.16,3136.32,1697.6,3177.4Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1769.84,
    y: 3136.96,
    width: 57.01,
    height: 176.98,
    transform: "translate(-2920.84 2317.03) rotate(-91.36)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1754,3140.35c7.84,3.39,21.3,13.48,26.64,50.37l-148.57,53.14c-3.79-.46-30.78-4.09-38.63-22.17-3.82-8.8-3.15-21.11-2.68-29.75a112.19,112.19,0,0,1,1.75-14.54,159.94,159.94,0,0,0,23.93,0c25.4-1.93,40.54-9.29,73-21.28C1742.38,3136.56,1749.8,3138.53,1754,3140.35Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1957.16,3207.94l-16.31,52.65L1894,3243.68l14.1-45.52a145,145,0,0,1,16.46,1.37A150.67,150.67,0,0,1,1957.16,3207.94Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1985.57,3187.64l-24.53,79.2-42-14.12a476.56,476.56,0,0,1,32.24-46.91q4.71-6.06,9.51-11.85a34.4,34.4,0,0,1,12.74-5.38A47.62,47.62,0,0,1,1985.57,3187.64Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1857.74,3320.1l-39.43,23.78-20-36.85,34.09-20.55a123.48,123.48,0,0,1,9.57,10.09A127.8,127.8,0,0,1,1857.74,3320.1Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1886.81,3323.35l-59.31,35.76L1809,3326.73a394.7,394.7,0,0,1,46.23-11.25q6.32-1.14,12.54-2.07a28.87,28.87,0,0,1,11,3.79A40.3,40.3,0,0,1,1886.81,3323.35Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1677.71,2970.1c2.33,10.27-10.67,26.76-27.32,30.06-14.05,2.79-30.27-3.9-34.33-14-1.82-4.52.4-5.79-1.7-17.35-1.71-9.48-3.67-11.19-2.82-16.35,1-5.82,4.41-9.7,8.21-14,4.42-4.94,8.66-9.68,16-11.64a26.19,26.19,0,0,1,22.86,4.62,25.61,25.61,0,0,1,6.85,9c2.79,5.88,1.44,8.61,3.25,14.63C1671.44,2964.2,1676.45,2964.53,1677.71,2970.1Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1660.76,2934.54c-5.82.55-12.68,2.25-16.13,7.47-5.64,8.53.42,22.54-1.47,23.13s-6.11-9.43-7.64-8.88c-1.72.61,3.89,13.14.85,26.87a39.41,39.41,0,0,1-6.66,14.53c-22.18-11.55-34.3-31.73-30.84-48,2.13-10,10.05-17.91,10.41-18.25,6.68-6.49,13.72-8.42,22.5-10.83,11-3,23.08-6.33,28-.41C1660.71,2921.22,1663.52,2925.12,1660.76,2934.54Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1638.6,
    cy: 2964.51,
    rx: 5.62,
    ry: 11.54,
    transform: "translate(-1810.49 -2614.78) rotate(-5.43)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1744.88,3127l-24.57,27c-9.11-1-53.44-6.84-85.92-46.22-29.69-36-29.69-76.06-29.39-86.23,2.23-3,9.27-11.67,18.88-11.66,8.5,0,14.72,6.9,20.65,14.36,22.51,28.31,21.82,41.07,39.53,63.26,15.71,19.67,31,28.05,35.48,30.41A101.56,101.56,0,0,0,1744.88,3127Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 41.15,
    cy: 168.62,
    rx: 17.23,
    ry: 16.39
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 23.92,
    cy: 166.64,
    rx: 17.23,
    ry: 16.39
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 23.06,
    cy: 188.88,
    rx: 17.23,
    ry: 16.39
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 41.15,
    cy: 199.41,
    rx: 17.23,
    ry: 16.39
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 28.76,
    cy: 210.4,
    rx: 17.23,
    ry: 16.39
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 41.15,
    cy: 225.31,
    rx: 17.23,
    ry: 16.39
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 29.76,
    cy: 241.7,
    rx: 17.23,
    ry: 16.39
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 23.06,
    cy: 260.44,
    rx: 11.53,
    ry: 10.96
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 12.53,
    cy: 225.31,
    rx: 11.53,
    ry: 10.96
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 12.53,
    cy: 194.02,
    rx: 11.53,
    ry: 10.96
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 11.53,
    cy: 210.4,
    rx: 11.53,
    ry: 10.96
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1832.46,3273.52l-46.9,31.47q-42.7-70.75-85.42-141.49l52.65-25a69.09,69.09,0,0,1,8.77,5.32c21,15,26.21,37.35,28.46,45.69C1794.93,3207.7,1806,3234.15,1832.46,3273.52Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1768.09,
    y: 3151.18,
    width: 11.28,
    height: 34.06,
    rx: 4.29,
    transform: "translate(2655.38 3092.85) rotate(167.46)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1735.9,3144.83c1.39-7.85,16.55-14.6,27.41-9.18,9.88,4.94,13.91,18.34,9.17,27.41-3.62,6.94-12.58,11.74-18.15,9.46-3.49-1.43-3.07-4.58-8.4-13C1739.53,3149.38,1735.27,3148.4,1735.9,3144.83Z",
    transform: "translate(-1537.46 -2783.04)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1765.31,
    y: 3161.86,
    width: 10.9,
    height: 34.06,
    rx: 4.14,
    transform: "translate(1898.53 3631.26) rotate(-178.11)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1758.09,
    y: 3169.25,
    width: 10.9,
    height: 20.47,
    rx: 4.14,
    transform: "translate(1569.59 3774.93) rotate(-172.67)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1748.88,
    y: 3165.54,
    width: 10.9,
    height: 13.95,
    rx: 4.14,
    transform: "translate(1552.14 3759.89) rotate(-172.67)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlSitting);
export default __webpack_public_path__ + "static/media/GirlSitting.ef5f1fe8df9f8e42a67917f356e7bbd7.svg";
export { ForwardRef as ReactComponent };